<template>
  <div class="col-12 col-lg-8">
    <div class="dashboard-card">
      <p>
        Hello super admin! Your account details should be edited in
        <a :href="djangoUrl" target="_blank">Django</a>.
      </p>
      <p><a :href="resetPasswordUrl">Reset your password.</a></p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SuperAdminAccount',

  data() {
    return {
      djangoUrl: `${process.env.VUE_APP_API_BASE_URL}/admin`,
      resetPasswordUrl: this.$globals.keycloak.createLoginUrl({
        action: 'UPDATE_PASSWORD'
      })
    };
  }
};
</script>
